module.exports = __webpack_public_path__ + "assets/images/51dc70d0fc6b1e8334eacc410a6c58c2.png";